<template>
  <div class="rocket-info max-width-100">
    <div class="info-text">
      <label class="info-textDaysInApp d-flex flex-column max-width-70">
        <div>{{ title }}</div>
        <div class="h6 text-truncate m-0">
          <small>
            {{ description ? description : '' }}
          </small>
        </div>
      </label>
      <div class="info-level">
        <label class="level-number">Level {{ level }}</label>
      </div>
    </div>
    <div class="info-xpBar">
      <div class="info-xpBar-progress" :style="styleBar">
        <img class="info-xpBar-rocket" src="@/assets/icons/icon-rocket.svg" alt="image" />
      </div>
      <div class="info-xpBar-container"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ExperienceBar',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: 'Example title',
    },
    description: {
      type: String,
      default: '',
    },
    level: {
      type: String,
      default: '0',
    },
  },
  computed: {
    ...mapGetters('user', [
      'getUserName',
      'userIsAParent',
      'getUserScore',
      'getUserScoreAll',
      'getUserLevel',
    ]),
    styleBar() {
      return { width: `${this.percentage}%` };
    },
  },
};
</script>
<style lang="scss" scoped>
.max-width-100 {
  max-width: 100%;
}
.max-width-70 {
  max-width: 70%;
}

* {
  position: relative;
  margin: 0;
  padding: 0;
}

template > div {
  width: 100%;
}

.rocket-info {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
}

.info-text {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 40px;
  @media (max-width: 820px) {
    align-items: baseline;
  }
}

.info-textDaysInApp {
  color: #2c2164;
  font-size: calc(1.15vw + 0.6rem);
}

.info-level {
  color: #2c2164;
  font-size: calc(1.15vw + 0.6rem);
  display: flex;
  justify-content: center;
  align-items: center;
  & > label {
    line-height: 1rem;
  }
  @media (max-width: 820px) {
    flex-direction: column-reverse;
    .level-text {
      font-size: 1rem;
    }
    .level-number {
      font-size: 30px;
      @media screen and (max-width: 480px) {
        font-size: 20px;
        min-width: 70px;
      }
    }
  }
}

.info-xpBar {
  display: flex;
  text-align: center;
  flex-grow: 1;
  width: 100%;
  height: auto;
}

.info-xpBar-rocket {
  position: absolute;
  left: calc(100% - 20px);
  top: calc(-27px / 6);
  height: 27px;
  z-index: 500;
}

.info-xpBar-progress {
  position: absolute;
  background: rgb(255, 199, 78);
  background: linear-gradient(90deg, rgba(255, 199, 78, 1) 65%, rgba(255, 152, 59, 1) 100%);
  // width: 75%;
  height: 20px;
  border-radius: 10px;
  z-index: 250;
}

.info-xpBar-container {
  background-color: white;
  width: 100%;
  height: 20px;
  border-radius: 10px;
}
</style>
